<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Seminar Title",
        value: "seminarTitle",
        sortable: false
      },
      {
        text: "Date From",
        value: "dateFrom",
        sortable: false
      },
      {
        text: "Date To",
        value: "dateTo",
        sortable: false
      },
      {
        text: "Hours Day",
        value: "hoursDay",
        sortable: false
      },
      {
        text: "Cost",
        value: "cost",
        sortable: false
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: false
      },
      {
        text: "Venue",
        value: "venue",
        sortable: false
      },
      {
        text: "Provider",
        value: "provider",
        sortable: false
      },
      {
        text: "Duration",
        value: "duration",
        sortable: false
      },
      {
        text: "Time From",
        value: "timeFrom",
        sortable: false
      },
      {
        text: "Time To",
        value: "timeTo",
        sortable: false
      },
      {
        text: "Relation",
        value: "relation",
        sortable: false
      },
      {
        text: "Reference",
        value: "reference",
        sortable: false
      },
      {
        text: "Month No",
        value: "monthNo",
        sortable: false
      },
      {
        text: "With Contract",
        value: "withContract",
        sortable: false
      },
      {
        text: "Org Sponsor",
        value: "orgSponsor",
        sortable: false
      },
      {
        text: "Comp Sponsor",
        value: "compSponsor",
        sortable: false
      },
      {
        text: "Ratings",
        value: "ratings",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "SEMTRAIN"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return (
          item.property == "ALL" &&
          item.mode == "SEMTRAIN" &&
          item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>